import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, CardContent, Divider, MenuItem, Grid, InputLabel, TextField, Button, Typography, Chip } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import MaterialTable from "material-table";
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";
import { Formik } from 'formik';
import * as Yup from "yup";
import { groupBy } from 'lodash';
import CheckIcon from '@material-ui/icons/Check';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { LoadingComponent } from 'src/utils/newLoader';
import xlsx from 'json-as-xlsx';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useAlert } from 'react-alert';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
}));

var screenCode = "ACCOUNTPAYABLE"

export default function AccountPayableListing() {
  const classes = useStyles();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [selectedFromDate, setSelectedFromDate] = useState(new Date());
  const [selectedToDate, setSelectedToDate] = useState(new Date());
  const [gridArray, setGridArray] = useState([]);
  const [voucherTypes, setVoucherTypes] = useState();
  const [pendingCount, setPendingCount] = useState(0);
  const [sessionDataForReceiving, setSessionDataForReceiving] = useState(null);
  const [suppliers, setSuppliers] = useState();
  const [transactionModes, setTransactionModes] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [suppliersAuto, setSuppliersAuto] = useState();
  const [accountPayable, setAccountPayable] = useState({
    groupID: '0',
    factoryID: '0',
    statusID: '0',
    transactionTypeID: '0',
    invoiceNo: '',
    transactionMode: '0',
    supplierID: '0',
  })
  const navigate = useNavigate();
  const alert = useAlert();
  let encrypted = "";
  let encryptedgroupID = "";
  let encryptedfactoryID = "";
  let encryptedVoucherCode = "";

  const handleDateChangeFrom = (date) => {
    setSelectedFromDate(date);
    if (selectedToDate < date) {
      setSelectedToDate(date);
    }
  };
  const handleDateChangeTo = (date) => {
    setSelectedToDate(date);
  };
  const handleClick = () => {
    encrypted = btoa('0');
    encryptedVoucherCode = btoa('0');
    encryptedgroupID = btoa('0');
    encryptedfactoryID = btoa('0');
    navigate('/app/accountPayable/addedit/' + encrypted + "/" + encryptedVoucherCode + "/" + encryptedgroupID + "/" + encryptedfactoryID);
  }
  const handleClickEdit = (invoiceDetailID, referenceNumber) => {
    sessionStorageData();
    encrypted = btoa(invoiceDetailID.toString());
    encryptedVoucherCode = btoa(referenceNumber.toString());
    encryptedgroupID = btoa(accountPayable.groupID.toString());
    encryptedfactoryID = btoa(accountPayable.factoryID.toString());
    navigate('/app/accountPayable/addedit/' + encrypted + "/" + encryptedVoucherCode + "/" + encryptedgroupID + "/" + encryptedfactoryID);
  }
  const handleClickApprove = (invoiceDetailID, referenceNumber) => {
    sessionStorageData();
    encrypted = btoa(invoiceDetailID.toString());
    encryptedVoucherCode = btoa(referenceNumber.toString());
    encryptedgroupID = btoa(accountPayable.groupID.toString());
    encryptedfactoryID = btoa(accountPayable.factoryID.toString());
    navigate('/app/accountPayable/approve/' + encrypted + "/" + encryptedVoucherCode + "/" + encryptedgroupID + "/" + encryptedfactoryID);
  }
  const handleClickView = (invoiceDetailID, referenceNumber) => {
    sessionStorageData();
    encrypted = btoa(invoiceDetailID.toString());
    encryptedVoucherCode = btoa(referenceNumber.toString());
    encryptedgroupID = btoa(accountPayable.groupID.toString());
    encryptedfactoryID = btoa(accountPayable.factoryID.toString());
    navigate('/app/accountPayable/view/' + encrypted + "/" + encryptedVoucherCode + "/" + encryptedgroupID + "/" + encryptedfactoryID);
  }
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isJournalApproveEnable: false,
    isAddEnabled: false,
    isEditEnabled: false,
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '',
    estateName: '',
    fromdate: '',
    todate: '',
    transactionModeName: '',
    supplierName: '',
    invoice: '',
    statusID: 0,
  });
  const [totalValues, setTotalValues] = useState({
    totalAmount: 0
  });
  const dataIsLoaded = groups && factories && transactionModes && suppliers;
  useEffect(() => {
    trackPromise(
      getGroupsForDropdown(),
      getVoucherTypeList(),
    );
    const IDdata = JSON.parse(
      sessionStorage.getItem('Journal-listing-page-search-parameters')
    );
    getPermissions(IDdata);
  }, []);

  useEffect(() => {
    sessionStorage.removeItem(
      'Journal-listing-page-search-parameters'
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesByGroupID()
    )
  }, [accountPayable.groupID]);

  useEffect(() => {
    checkPendingCount();
  }, [gridArray]);

  useEffect(() => {
    setGridArray([])
  }, [accountPayable]);

  useEffect(() => {
    if (sessionDataForReceiving !== null) {
      handleSearch();
    }
  }, [sessionDataForReceiving]);

  useEffect(() => {
    if (accountPayable.factoryID.toString() !== '0') {
      trackPromise(getTransactionModeList());
      trackPromise(getSuppliersForDropDownAuto(), getSuppliersForDropDown());
    }
  }, [accountPayable.factoryID]);

  useEffect(() => {
    setAccountPayable({
      ...accountPayable,
      supplierID: '0',
    })
  }, [accountPayable.transactionMode]);

  useEffect(() => {
    if (gridArray.length != 0) {
      calculateTotal();
    }
  }, [gridArray]);

  useEffect(() => {
    if (dataIsLoaded) {
      const storedSearchValues = sessionStorage.getItem('Journal-listing-page-search-values');
      if (storedSearchValues) {
        const parsedValues = JSON.parse(storedSearchValues);
        setSelectedSearchValues({
          groupName: parsedValues.groupName || '',
          estateName: parsedValues.estateName || '',
          fromdate: parsedValues.fromdate || '',
          todate: parsedValues.todate || '',
          transactionModeName: parsedValues.transactionModeName || '',
          supplierName: parsedValues.supplierName || '',
          invoice: parsedValues.invoice || '',
          statusID: parsedValues.statusID || 0,
        });
      }
    }
  }, [dataIsLoaded]);

  async function getPermissions(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITACCOUNTPAYABLE');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isJournalApproveEnable = permissions.find(p => p.permissionCode == 'ACCOUNTPAYABLEAPPROVEBUTTONENABLED');
    var isAddEnabled = permissions.find(p => p.permissionCode == 'ADDEDITACCOUNTPAYABLE');
    var isEditEnabled = permissions.find(p => p.permissionCode == 'EDITACCOUNTPAYABLE');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isJournalApproveEnable: isJournalApproveEnable !== undefined,
      isAddEnabled: isAddEnabled !== undefined,
      isEditEnabled: isEditEnabled !== undefined,
    });

    const initialValues = IDdata === null;
    if (initialValues) {
      setAccountPayable({
        ...accountPayable,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        factoryID: parseInt(tokenService.getFactoryIDFromToken()),
      });
    }
    else {
      setAccountPayable({
        ...accountPayable,
        groupID: parseInt(IDdata.groupID),
        factoryID: parseInt(IDdata.factoryID),
        transactionTypeID: IDdata.transactionTypeID,
        invoiceNo: IDdata.invoiceNo,
        statusID: IDdata.statusID,
        supplierID: IDdata.supplierID,
        transactionMode: IDdata.transactionMode
      })
      setSelectedFromDate(new Date(IDdata.selectedFromDate))
      setSelectedToDate(new Date(IDdata.selectedToDate))
      setVoucherTypes(IDdata.voucherTypes)
      setSessionDataForReceiving(IDdata)
    }
  }

  async function checkPendingCount() {
    let count = Array.isArray(gridArray) ? gridArray.filter(x => x.status === 1) : [];
    setPendingCount(count.length);
  }

  async function getFactoriesByGroupID() {
    const fac = await services.getFactoriesByGroupID(accountPayable.groupID);
    setFactories(fac);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  function generateDropownForTransactionModeList(dataList) {
    let items = []
    if (dataList != null) {
      transactionModes.forEach(x => {
        items.push(<MenuItem key={x.payableModeID} value={x.payableModeID}>{x.payableModeName}</MenuItem>)
      });
    }
    return items
  }
  async function getSuppliersForDropDownAuto() {
    const supplierResult = await services.getSuppliersForDropDownAuto(
      accountPayable.factoryID
    );
    setSuppliersAuto(supplierResult);
  }

  function handleSearchDropdownChangeFieldsSupplier(data, e) {
    if (data === undefined || data === null) {
      setAccountPayable({
        ...accountPayable,
        supplierID: '0'
      });
      return;
    } else {
      var valueV = data["supplierID"];
      setAccountPayable({
        ...accountPayable,
        supplierID: valueV
      });
    }
  }
  async function getSuppliersForDropDown() {
    const supplierResult = await services.getSuppliersForDropDown(
      accountPayable.factoryID
    );
    setSuppliers(supplierResult);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function generateDropDownMenuWithTwoValues(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value.name}</MenuItem>);
      }
    }
    return items
  }

  async function getVoucherTypeList() {
    const voucherTypes = await services.getVoucherTypeList();
    voucherTypes.forEach(x => {
      if (x.screenCode == 'JOURNAL') {
        setVoucherTypes(x.voucherTypeID)
      }
    });
  }

  async function getTransactionModeList() {
    const transactionModes = await services.getTransactionModeList();
    setTransactionModes(transactionModes);
    return transactionModes
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setAccountPayable({
      ...accountPayable,
      [e.target.name]: value
    });
  }

  function handleChangeSupplier(e) {
    const target = e.target;
    const value = target.value;
    setAccountPayable({
      ...accountPayable,
      [e.target.name]: value
    });
  }

  function calculateTotal() {
    const totalAmount = gridArray.reduce((accumulator, current) => {
      const progressFraction = current.amount;
      return accumulator + progressFraction;
    }, 0);

    setTotalValues({
      ...totalValues,
      totalAmount: totalAmount
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
            isEdit={true}
            toolTiptitle={"Add Account Payable"}
            disabled={!permissionList.isAddEnabled}
          />
        </Grid>
      </Grid>
    )
  }

  function clearData() {
    setAccountPayable({
      ...accountPayable,
      groupID: accountPayable.groupID,
      factoryID: accountPayable.factoryID,
      supplierID: '0',
      statusID: '0',
      transactionTypeID: '0',
      invoiceNo: '',
      transactionMode: '0'
    });
    setSelectedFromDate(new Date())
    setSelectedToDate(new Date())
    setGridArray([]);
  }

  async function handleSearch() {
    let model = {
      groupID: parseInt(accountPayable.groupID),
      factoryID: parseInt(accountPayable.factoryID),
      transactionMode: parseInt(accountPayable.transactionMode) === 0 ? null : parseInt(accountPayable.transactionMode),
      supplierID: parseInt(accountPayable.supplierID) === 0 ? null : parseInt(accountPayable.supplierID),
      invoiceNo: accountPayable.invoiceNo && accountPayable.invoiceNo.toString().trim() !== "" ? accountPayable.invoiceNo.toString() : null,
      fromdate: selectedFromDate == null ? null : new Date(selectedFromDate).toISOString(),
      todate: selectedToDate == null ? null : new Date(selectedToDate).toISOString(),
      statusID: parseInt(accountPayable.statusID) === 0 ? null : parseInt(accountPayable.statusID)
    };

    getSelectedDropdownValuesForReport(model)
    const response = await services.getAccountPayableDetails(model);
    if (response.statusCode == "Success") {
      const groupByReferenceNumber = groupBy(response.data, "invoiceNo");
      let keys = Object.keys(groupByReferenceNumber);
      let arrayCollection = [];

      keys.forEach(x => {
        arrayCollection.push(groupByReferenceNumber[x][0]);
      });
      let result = arrayCollection.filter((x) => x.voucherType == parseInt(voucherTypes));
      setGridArray(response.data);
    }
    else {
      alert.error("No Records To Display")
    }

  }

  function statusCheck(data) {
    if (data == 1) { return "Pending" }
    else if (data == 2) { return "Approved" }
    else { return "Rejected" }
  }

  function sessionStorageData() {
    let model = {
      groupID: parseInt(accountPayable.groupID),
      factoryID: parseInt(accountPayable.factoryID),
      transactionTypeID: accountPayable.transactionTypeID,
      invoiceNo: accountPayable.invoiceNo,
      supplierID: accountPayable.supplierID,
      transactionMode: accountPayable.transactionMode,
      statusID: accountPayable.statusID,
      selectedFromDate: new Date(selectedFromDate),
      selectedToDate: new Date(selectedToDate),
      voucherTypes: voucherTypes
    };
    sessionStorage.setItem(
      'Journal-listing-page-search-parameters',
      JSON.stringify(model)
    );
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    if (!dataIsLoaded) return;

    const updatedValues = {
      groupName: groups[searchForm.groupID] || '',
      estateName: factories[searchForm.factoryID] || '',
      fromdate: searchForm.fromdate || '',
      todate: searchForm.todate || '',
      transactionModeName: transactionModes.find(mode => mode.payableModeID === searchForm.transactionMode)?.payableModeName || 'All',
      supplierName: suppliers[searchForm.supplierID]?.name ?? '-',
      invoice: searchForm.invoiceNo == null ? 'All' : searchForm.invoiceNo,
      statusID: parseInt(searchForm.statusID) === 0 ? 'All' : searchForm.statusID,
    };

    setSelectedSearchValues(updatedValues);
    sessionStorage.setItem('Journal-listing-page-search-values', JSON.stringify(updatedValues));
  }
  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        var vr = {
          'Invoice Date': x.invoiceDate ? new Date(x.invoiceDate).toISOString().split('T')[0] : '-',
          'Invoice No': x.invoiceNo,
          'Supplier': x.supplierName ? x.supplierName : '-',
          'Description': x.payableDescription ? x.payableDescription : '-',
          'Entered By': x.createdByName,
          'Status': x.status == 1 ? 'Pending' : x.status == 2 ? 'Approved' : x.status == 3 ? 'Rejected' : '-',
          'Amount': x.amount,
        }
        res.push(vr);
      });

      res.push({});
      var vrTot = {
        'Invoice Date': "Total   ",
        'Amount': totalValues.totalAmount,
      }
      res.push(vrTot);
      res.push({});

      var vr = {
        'Invoice Date': "Group : " + selectedSearchValues.groupName,
        'Invoice No': "Factory : " + selectedSearchValues.estateName,
      }
      res.push(vr);

      var vr2 = {
        'Invoice Date': "From Date : " + selectedFromDate.toISOString().split('T')[0],
       'Invoice No': "To Date : " + selectedToDate.toISOString().split('T')[0],
      }
      res.push(vr2);

      var vr4 = {
        'Invoice Date': "Transaction Mode : " + selectedSearchValues.transactionModeName,
        'Invoice No': "Supplier : All" 
      }
      res.push(vr4);

      var vr6 = {
        'Invoice Date': "Invoice No : " + selectedSearchValues.invoice,
        'Invoice No': "Status : " + (parseInt(selectedSearchValues.statusID) == 0 ? 'All' : parseInt(selectedSearchValues.statusID) == 1 ? 'Pending' : parseInt(selectedSearchValues.statusID) == 2 ? 'Approved' : parseInt(selectedSearchValues.statusID) == 3 ? 'Rejected' : 'All'),
      }
      res.push(vr6);

    }
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(gridArray);
    var settings = {
      sheetName: 'Account Payable Report',
      fileName: `Account Payable Report - ${selectedSearchValues.groupName} - ${selectedSearchValues.estateName}`, 
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: 'Account Payable Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  return (
    <Page
      className={classes.root}
      title="Account Payable"
    >
      <Container maxWidth={false}>
        <Formik
          initialValues={{
            groupID: accountPayable.groupID,
            factoryID: accountPayable.factoryID,
          }}
          validationSchema={
            Yup.object().shape({
              groupID: Yup.number().required('Group is required').min("1", 'Select a group'),
              factoryID: Yup.number().required('Factory is required').min("1", 'Select a factory'),
            })
          }
          onSubmit={() => trackPromise(handleSearch())}
          enableReinitialize
        >
          {({
            errors,
            handleBlur,
            handleSubmit,
            touched,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={0}>
                <LoadingComponent />
                <Card>
                  <CardHeader
                    title={cardTitle("Account Payable")}
                  />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent style={{ marginBottom: "2rem" }}>
                      <Grid container spacing={3}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="groupID">Group *</InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            helperText={touched.groupID && errors.groupID}
                            fullWidth
                            size='small'
                            name="groupID"
                            onChange={(e) => handleChange(e)}
                            value={accountPayable.groupID}
                            variant="outlined"
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled ? true : false
                            }}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="factoryID">Factory *</InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            helperText={touched.factoryID && errors.factoryID}
                            fullWidth
                            size='small'
                            name="factoryID"
                            onChange={(e) => handleChange(e)}
                            value={accountPayable.factoryID}
                            variant="outlined"
                            id="factoryID"
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                            }}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink style={{ marginBottom: '-8px' }}>Entry From Date</InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              fullWidth
                              inputVariant="outlined"
                              format="dd/MM/yyyy"
                              margin="dense"
                              id="from-date-picker"
                              variant='inline'
                              value={selectedFromDate}
                              onChange={handleDateChangeFrom}
                              maxDate={new Date()}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                              autoOk
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink style={{ marginBottom: '-8px' }}>Entry To Date</InputLabel>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              fullWidth
                              inputVariant="outlined"
                              format="dd/MM/yyyy"
                              margin="dense"
                              variant='inline'
                              id="to-date-picker"
                              value={selectedToDate}
                              onChange={handleDateChangeTo}
                              minDate={selectedFromDate}
                              maxDate={new Date()}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                              autoOk
                            />
                          </MuiPickersUtilsProvider>
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="transactionMode">
                            Transaction Mode
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.transactionMode && errors.transactionMode)}
                            fullWidth
                            helperText={touched.transactionMode && errors.transactionMode}
                            name="transactionMode"
                            size='small'
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e)
                            }}
                            value={accountPayable.transactionMode}
                            variant="outlined"
                            id="transactionMode"
                          >
                            <MenuItem value="0">--Select Transaction Mode--</MenuItem>
                            {generateDropownForTransactionModeList(transactionModes)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="supplierID">
                            Supplier
                          </InputLabel>
                          <Autocomplete
                            id="supplierID"
                            options={suppliersAuto || []}
                            getOptionLabel={(option) => option?.supplierName || "Unnamed Supplier"}
                            onChange={(e, value) => handleSearchDropdownChangeFieldsSupplier(value, e)}
                            value={
                              suppliersAuto?.find(
                                (option) => option.supplierID === accountPayable.supplierID
                              ) || null
                            }
                            disabled={accountPayable.transactionMode !== 1}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                name="supplierID"
                                fullWidth
                                size="small"
                                placeholder="--Select Supplier--"
                                onBlur={handleBlur}
                                error={Boolean(touched.supplierID && errors.supplierID)}
                                helperText={touched.supplierID && errors.supplierID}

                              />
                            )}
                          />
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="invoiceNo">Invoice No </InputLabel>
                          <TextField
                            fullWidth
                            size='small'
                            name="invoiceNo"
                            onChange={(e) => handleChange(e)}
                            value={accountPayable.invoiceNo}
                            variant="outlined"
                          />
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="statusID">
                            Status
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.statusID && errors.statusID)}
                            fullWidth
                            helperText={touched.statusID && errors.statusID}
                            name="statusID"
                            onBlur={handleBlur}
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={accountPayable.statusID}
                            variant="outlined"
                            id="statusID"
                          >
                            <MenuItem value="0">All</MenuItem>
                            <MenuItem value="1">Pending</MenuItem>
                            <MenuItem value="2">Approved</MenuItem>
                            <MenuItem value="3">Rejected</MenuItem>
                          </TextField>
                        </Grid>
                      </Grid>

                      <Box display="flex" flexDirection="row-reverse" p={2} >
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                        >
                          Search
                        </Button>
                        <div>&nbsp;</div>
                        <Button
                          color="primary"
                          type="reset"
                          variant="outlined"
                          onClick={() => clearData()}
                        >
                          Clear
                        </Button>
                      </Box>
                    </CardContent>

                    {pendingCount > 0 ?
                      <Grid container spacing={2}>
                        <Grid item xs={4} spacing={2}>
                          <Typography color="textSecondary" gutterBottom>
                            <Chip style={{ marginLeft: '1rem', backgroundColor: "#FFFDD0 ", color: 'black', }} alignContent="center"
                              icon={<AccessTimeIcon />}
                              label={"Pending count : " + pendingCount}
                              clickable
                              color="primary"
                            />
                          </Typography>
                        </Grid>
                      </Grid> : null}

                    {gridArray.length > 0 ?
                      <Box minWidth={1000} >
                        <MaterialTable
                          title="Multiple Actions Preview"
                          columns={[
                            { title: 'Invoice Date', field: 'invoiceDate', render: rowdata => rowdata.invoiceDate.split('T')[0] },
                            { title: 'Invoice No', field: 'invoiceNo' },
                            {
                              title: 'Supplier',
                              field: 'supplierName',
                              render: rowdata => rowdata.supplierName ? rowdata.supplierName : '-'
                            },
                            {
                              title: 'Description',
                              field: 'payableDescription',
                              render: rowdata => rowdata.payableDescription ? rowdata.payableDescription : '-'
                            },
                            { title: 'Entered By', field: 'createdByName' },
                            {
                              title: 'Status', field: 'status',
                              lookup: {
                                1: 'Pending',
                                2: 'Approved',
                                3: 'Rejected',
                              },
                              defaultSort: "desc",
                              render: rowData => {
                                if (rowData.status == 1) {
                                  return <div style={{ backgroundColor: "#FFFDD0", padding: "10px", borderRadius: "5px" }}>
                                    <span >{statusCheck(rowData.status)}</span>
                                  </div>
                                }
                                else if (rowData.status == 2) {
                                  return <div style={{ padding: "10px", borderRadius: "5px" }}>
                                    <span >{statusCheck(rowData.status)}</span>
                                  </div>
                                }
                                else {
                                  return <div style={{ padding: "10px", borderRadius: "5px" }}>
                                    <span >{statusCheck(rowData.status)}</span>
                                  </div>
                                }
                              },
                            },
                          ]}
                          data={gridArray}
                          options={{
                            exportButton: false,
                            showTitle: false,
                            headerStyle: { textAlign: "left", height: '1%' },
                            cellStyle: { textAlign: "left" },
                            columnResizable: false,
                            actionsColumnIndex: -1
                          }}
                          actions={[
                            rowData => ({
                              hidden: (rowData.status !== 1),
                              disabled: (!permissionList.isEditEnabled),
                              icon: 'edit',
                              tooltip: 'Edit',
                              onClick: (event, rowData) => handleClickEdit(rowData.invoiceDetailID, rowData.referenceNumber)
                            }),
                            rowData => (
                              {
                                hidden: (rowData.status !== 1 || !permissionList.isJournalApproveEnable),
                                icon: CheckIcon,
                                tooltip: 'Approve',
                                onClick: (event, rowData) => handleClickApprove(rowData.invoiceDetailID, rowData.referenceNumber),
                              }),
                            {
                              icon: VisibilityIcon,
                              tooltip: 'View',
                              onClick: (event, rowData) => handleClickView(rowData.invoiceDetailID, rowData.referenceNumber)
                            }
                          ]}
                        />
                      </Box> : null
                    }
                    {gridArray.length > 0 ?
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          id="btnRecord"
                          type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem', backgroundColor: 'green', color: 'white' }}
                          className={classes.colorRecord}
                          onClick={createFile}
                        >
                          EXCEL
                        </Button>
                      </Box>
                      : null}
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
    </Page>
  );
};

